<template>
  <section>
    <div class="grid gap-4 lg:grid-cols-4 md:grid-cols-3">
      <div v-for="d in data" :key="d.id">
        <!-- <router-link :to="{ name: 'session', params: { id: d.id } }"> -->
        <div
          class="flex shadow p-3 ring-1 rounded-lg hover:shadow-lg ring-gray-300 mb-6"
        >
          <img
            class="object-cover w-24 h-24 rounded"
            :src="baseUrlSrc(d.thumbnail_url)"
            alt=""
            @error="defaultImage"
          />
          <div class="px-4">
            <div>
              <div class="text-gray-dark font-bold text-md capitalize">
                {{ handleStr(d.title, 13) }}
              </div>
              <p class="text-gray-350 text-sm">
                {{ hourToMinConverter(d.duration) }} Hours
              </p>
            </div>
          </div>
        </div>
        <!-- </router-link> -->
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "CourseSessionListCard",
  props: {
    data: Array,
  },
};
</script>